/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerDeliveryAddressService = {
  async getByName(name) {
    const requestScreenData = {
      url: "api/CustomerDeliveryAddress",
      top: "1",
      filter: `CompanyName eq '${name}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(code) {
    const requestScreenData = {
      url: "api/CustomerDeliveryAddress",
      top: "1",
      filter: `CustomerCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getAllByCode(code) {
    const requestScreenData = {
      url: "api/CustomerDeliveryAddress",
      filter: `CustomerCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCodeAndLineNo(code, lineNo) {
    const requestScreenData = {
      url: "api/CustomerDeliveryAddress",
      top: "1",
      filter: `CustomerCode eq '${code}' and LineNo eq ${lineNo}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/CustomerDeliveryAddress",
      expand: "Customer($select=Code,Name)",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, customerDeliveryAddress) {
    var payload = customerDeliveryAddress;
    var url = "api/CustomerDeliveryAddress";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.patch(
        url,
        customerDeliveryAddress.RecordId,
        payload,
        "Guid"
      );
    }
  },
  async delete(customerDeliveryAddress) {
    var payload = customerDeliveryAddress;
    var url = "api/CustomerDeliveryAddress";

    return await ApiService.delete(
      url,
      customerDeliveryAddress.RecordId,
      "Guid"
    );
  },
  async changeDefault(customerDeliveryAddress) {
    var payload = customerDeliveryAddress;
    var url = "api/Save_DefaultCustomerDeliveryAddress";

    return await ApiService.post(url, payload, "Guid");
  },
  async getCustomRequest(filter) {
    const requestScreenData = {
      url: "api/CustomerDeliveryAddress",
      top: "1",
      filter: filter,
    };
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerDeliveryAddressService };
